import React, { useEffect, useState } from "react";
// import HeroTerms from "../assets/img/HeroTerms378.png";
function TermsOfUse(props) {
  return (
    <div>
         <div className='rentsec1'>
            <div className='rentsec1-left'>
                <div className="ms-5">

                <h6>Home/<span>Terms Of Use</span></h6>
                <h2>Terms Of Use</h2>
                <p>By accessing our website and services, you 
agree to abide by the following terms and conditions</p>
              
               </div>
            </div>
            <img src="BuildingIllustration.png" alt="" />
        </div>
      {/* <div className="w-[1440px] h-[378px] ">
        <img src={HeroTerms && HeroTerms} alt="about" className="w-full" />
      </div> */}
      <div className="w-[1240px] h-[1936px] mt-[56px] ml-[100px] mb-28 ">
        <div className="w-[1240px] h-[480px] ">
          <h2 className="w-[1240px] h-[44px] text-[36px]  font-semibold ">
            Linked Bricks Terms of Use
          </h2>
          <div className="w-[1240px] h-[416px] ">
            <p className="text-[18px] font-normal mt-4 mb-5">
              Your comprehensive platform for real estate sales, rentals, and
              property management. Experience features such as virtual tours,
              advanced marketing tools, and secure smart contracts using
              blockchain technology.
            </p>
            <p className="text-[18px] font-normal mb-4">
              Velit lectus ut id bibendum elit aliquam pretium gravida. In
              egestas etiam convallis quis nunc tristique scelerisque imperdiet.
              Nisi parturient mattis ligula posuere risus sit sed urna et. Fusce
              proin aenean dolor sapien aliquam quam viverra elit. Rhoncus donec
              fermentum est sit amet morbi integer. Ultrices nisi amet
              consectetur blandit turpis sit nulla elit a. Consectetur nisl
              augue maecenas donec malesuada habitant velit. Lacus viverra enim
              dis malesuada quis pharetra. Auctor integer lorem pellentesque eu
              semper egestas a faucibus. Mauris pellentesque pellentesque risus
              id augue viverra eget faucibus. Condimentum ipsum et tortor et
              proin cras.
            </p>
            <p className="text-[18px] font-normal ">
              Cursus tellus in nam natoque nulla sit cursus leo suspendisse.
              Ipsum ullamcorper urna in ipsum malesuada egestas ut. Gravida ut
              parturient facilisis cursus aliquam ac ac aliquam dictumst. Amet
              tempor mi felis et massa tempus pharetra feugiat. Nullam faucibus
              volutpat non libero in hendrerit libero. Leo mattis magna nisl
              neque vulputate tempor. Eu integer interdum quis lorem id.
              <br />
              Pretium malesuada sed purus est diam enim amet sit. Vel nullam
              duis ultrices semper. Eu maecenas et varius tortor fringilla et
              suscipit. Arcu elementum semper gravida lacus porta viverra nunc
              ultricies. Quis viverra scelerisque dignissim nulla integer sed in
              vitae vel. Commodo elementum tellus eu pulvinar faucibus. Vivamus
              dolor ut sociis ornare mauris egestas in. Elementum a feugiat
              volutpat id morbi diam. Fermentum molestie ac tristique eu arcu
              commodo risus sagittis ut.
            </p>
          </div>
        </div>

        <div className="w-[1240px] h-[220px] mt-[40px]  ">
          <h2 className="w-[1240px] h-[44px] text-[36px]  font-semibold ">
            Your responsibilities
          </h2>
          <div className="w-[1240px] h-[156px] mt-[20px]">
            <p className="text-[18px] font-normal mt-4 mb-5">
              Your comprehensive platform for real estate sales, rentals, and
              property management. Experience features such as virtual tours,
              advanced marketing tools, and secure smart contracts using
              blockchain technology.
            </p>
            <p className="text-[18px] font-normal mb-4">
              Donec pharetra orci in pretium fermentum fermentum libero gravida.
              Elementum nunc volutpat morbi augue risus consequat. Adipiscing
              suspendisse ornare vulputate porttitor in id suspendisse.
              Ullamcorper faucibus cursus sed turpis non sagittis. Feugiat ipsum
              ac ultrices lorem. Sem sit magna curabitur cras hendrerit. Proin
              amet vitae fermentum mi eu vitae egestas sed. Vel tortor libero
              sed suspendisse.
            </p>
          </div>
        </div>

        <div className="w-[1240px] h-[376px] mt-[40px] ">
          <h2 className="w-[1240px] h-[44px] text-[36px]  font-semibold ">
            Materials you provide
          </h2>
          <div className="w-[1240px] h-[312px] ">
            <p className="text-[18px] font-normal mt-3 mb-4">
              Your comprehensive platform for real estate sales, rentals, and
              property management. Experience features such as virtual tours,
              advanced marketing tools, and secure smart contracts using
              blockchain technology.
            </p>
            <p className="text-[18px] font-normal mb-1">
              Donec pharetra orci in pretium fermentum fermentum libero gravida.
              Elementum nunc volutpat morbi augue risus consequat. Adipiscing
              suspendisse ornare vulputate porttitor in id suspendisse.
              Ullamcorper faucibus cursus sed turpis non sagittis. Feugiat ipsum
              ac ultrices lorem. Sem sit magna curabitur cras hendrerit. Proin
              amet vitae fermentum mi eu vitae egestas sed. Vel tortor libero
              sed suspendisse. Nulla morbi id facilisis suspendisse. Elementum
              magna ornare consectetur integer mattis sit egestas. Nunc pulvinar
              senectus id cum dictum. Libero vitae placerat nullam sit vitae a
              commodo purus pellentesque. Pellentesque arcu orci pretium sapien
              duis hendrerit blandit dolor.
              <br /> Orci malesuada sit nunc massa a. Dolor purus dignissim
              nulla lorem vel accumsan nulla. Nisi id consectetur eu arcu semper
              purus velit proin lectus. Vitae imperdiet in lectus velit
              suspendisse. Convallis suspendisse nulla duis faucibus blandit
              dignissim donec vitae scelerisque. Aliquet elementum rutrum
              tincidunt volutpat sed faucibus. Libero urna sed hac bibendum
              massa eu consequat nec. Massa hac malesuada ipsum elementum
              aliquam iaculis aenean. Aliquam rhoncus fusce ac urna morbi
              turpis. Justo nunc tellus amet turpis odio.
            </p>
          </div>
        </div>

        <div className="w-[1240px] h-[272px] mt-[40px] ">
          <h2 className="w-[1240px] h-[44px] text-[36px]  font-semibold ">
            Disclaimer and liability
          </h2>
          <div className="w-[1240px] h-[208px] ">
            <p className="text-[18px] font-normal mt-3 mb-4">
              Your comprehensive platform for real estate sales, rentals, and
              property management. Experience features such as virtual tours,
              advanced marketing tools, and secure smart contracts using
              blockchain technology.
            </p>
            <p className="text-[18px] font-normal mb-1">
              Donec pharetra orci in pretium fermentum fermentum libero gravida.
              Elementum nunc volutpat morbi augue risus consequat. Adipiscing
              suspendisse ornare vulputate porttitor in id suspendisse.
              Ullamcorper faucibus cursus sed turpis non sagittis. Feugiat ipsum
              ac ultrices lorem. Sem sit magna curabitur cras hendrerit. Proin
              amet vitae fermentum mi eu vitae egestas sed. Vel tortor libero
              sed suspendisse. Nulla morbi id facilisis suspendisse. Elementum
              magna ornare consectetur integer mattis sit egestas. Nunc pulvinar
              senectus id cum dictum. Libero vitae placerat nullam sit vitae a
              commodo purus pellentesque. Pellentesque arcu orci pretium sapien
              duis hendrerit blandit
            </p>
          </div>
        </div>

        <div className="w-[1240px] h-[428px] mt-[40px] ">
          <h2 className="w-[1240px] h-[44px] text-[36px]  font-semibold ">
            Indemnification
          </h2>
          <div className="w-[1240px] h-[364px] ">
            <p className="text-[18px] font-normal mt-3 mb-4">
              Your comprehensive platform for real estate sales, rentals, and
              property management. Experience features such as virtual tours,
              advanced marketing tools, and secure smart contracts using
              blockchain technology.
            </p>
            <p className="text-[18px] font-normal mb-1">
              Donec pharetra orci in pretium fermentum fermentum libero gravida.
              Elementum nunc volutpat morbi augue risus consequat. Adipiscing
              suspendisse ornare vulputate porttitor in id suspendisse.
              Ullamcorper faucibus cursus sed turpis non sagittis. Feugiat ipsum
              ac ultrices lorem. Sem sit magna curabitur cras hendrerit. Proin
              amet vitae fermentum mi eu vitae egestas sed. Vel tortor libero
              sed suspendisse. Nulla morbi id facilisis suspendisse. Elementum
              magna ornare consectetur integer mattis sit egestas. Nunc pulvinar
              senectus id cum dictum. Libero vitae placerat nullam sit vitae a
              commodo purus pellentesque. Pellentesque arcu orci pretium sapien
              duis hendrerit blandit Ullamcorper faucibus cursus sed turpis non
              sagittis. Feugiat ipsum ac ultrices lorem. Sem sit magna curabitur
              cras hendrerit. Proin amet vitae fermentum mi eu vitae egestas
              sed. Vel tortor libero sed suspendisse. Nulla morbi id facilisis
              suspendisse. Elementum magna ornare consectetur integer mattis sit
              egestas. Nunc pulvinar senectus id cum dictum. Libero vitae
              placerat nullam sit vitae a commodo purus pellentesque.
              Pellentesque arcu orci pretium sapien duis hendrerit
              blanditUllamcorper faucibus cursus sed turpis non sagittis.
              Feugiat ipsum ac ultrices lorem. Sem sit magna curabitur cras
              hendrerit. Proin amet vitae fermentum mi eu vitae egestas sed. Vel
              tortor libero sed suspendisse. Nulla morbi id facilisis
              suspendisse. Elementum magna ornare consectetur integer mattis sit
              egestas. Nunc pulvinar senectus id cum dictum. Libero vitae
              placerat nullam sit vitae a commodo purus pellentesque.
              Pellentesque
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default TermsOfUse;
